import { DetailScanComponent } from './detail-scan.component';
import { ScanSplitButton, SuperButton } from '@devinforius/super-compos-17';
import { TranslateService } from '@devinforius/super-compos-17';
export function getButtonsTitle(component: DetailScanComponent, translate: TranslateService): SuperButton[] {
  return [
   {
      text: translate.translate('btn.cancel'),
      icon: 'bi bi-trash',
      styleClass: 'red',
      click: (): void => component.back(),
    },
    {
      text: translate.translate('btn.confirm'),
      icon: 'bi bi-pencil-square',
      styleClass: 'green',
      click: (): void => component.confirmAndSave(),
    }
  ];
}

export function getQuickButtonsIScan(translate: TranslateService): ScanSplitButton[] {
  return [{
    id: 'ModifyScan',
    tooltip: translate.translate('iscan.actions.modifyScan'),
    action: 'modifyScan',
    icon: 'bi bi-pencil-square',
  },
  {
    id: 'deleteLink',
    tooltip: translate.translate('iscan.actions.deleteLinkScan'),
    action: 'deleteLink',
    icon: 'bi bi-input-cursor',
  },
  {
    id: 'scrollFile',
    tooltip: translate.translate('iscan.actions.showFile'),
    action: 'scrollFile',
    icon: 'bi bi-mouse',
  },
  {
    id: 'downloadFile',
    tooltip: translate.translate('iscan.actions.downloadFile'),
    action: 'downloadFile',
    icon: 'bi bi-download',
  },];
}

